export default __webpack_public_path__ + "static/media/filter.080e31f0.svg";